import format from 'date-fns/format'

export const formatDate = (inputDate: Date | string) => {
  const parsedDate = new Date(inputDate)

  return format(parsedDate, 'D MMMM YYYY')
}

export default formatDate
